"use strict";
import Vue from 'vue'
//import HelloWorld from '@/components/HelloWorld.vue'
import Landing from '@/components/Landing.vue'
import Instrumentos from '@/components/Instrumentos.vue'
import Instrument from '@/components/Instrument.vue'
import InstrumentCertificado from '@/components/InstrumentCertificado.vue'
import InstrumentAnalise from '@/components/InstrumentAnalise.vue'
//import Notebook from '@/components/Notebook.vue'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

/*
import Home from '../views/Home.vue'


  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/ webpackChunkName: "about" / '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})
*/

const routes = [
  {
    path: '/instrumento/:id',
    //component: Instrument,
    component: () => import(/* webpackChunkName: "Instrument" */ '@/components/Instrument.vue'),
    name: 'instrumento',
    children: [
      {
        path: 'analise',
        //component: InstrumentAnalise,
        component: () => import(/* webpackChunkName: "InstrumentAnalise" */ '@/components/InstrumentAnalise.vue'),
        children: [
          {
            path: ':CodigoFaixaModelo',
            props: true
          }
        ],
        props: true
      },
      {
        path: 'certificado',
        //component: InstrumentCertificado,
        component: () => import(/* webpackChunkName: "InstrumentCertificado" */ '@/components/InstrumentCertificado.vue'),
        props: true
      },
      {
        path: '',
        //component: InstrumentCertificado,
        component: () => import(/* webpackChunkName: "InstrumentCertificado" */ '@/components/InstrumentCertificado.vue'),
        props: true
      }
    ]
  },
  {
    path: '/instrumentos',
    //component: Instrumentos,
    component: () => import(/* webpackChunkName: "Instrumentos" */ '@/components/Instrumentos.vue'),
    name: 'instrumentos'
  },
  {
    path: '/',
    //component: Instrumentos,
    component: () => import(/* webpackChunkName: "Instrumentos" */ '@/components/Instrumentos.vue'),
    name: 'instrumentos'
  }
  // ,
  // {
  //   path: '/notebook',
  //   component: Notebook,
  //   //component: () => import(/ webpackChunkName: "Instrumentos" / '@/components/Instrumentos.vue'),
  //   name: 'notebook'
  // }
  ,
  {
    path: '/landing',
    //component: Landing,
    component: () => import(/* webpackChunkName: "Landing" */ '@/components/Landing.vue'),
    name: 'landing'    
  }
]

const router = new VueRouter({
  /*mode: 'history',*/
  routes: routes,
  linkActiveClass: 'is-active'
})


export default router
